import React from 'react';
import SessionDateLink from '../shared/session_date_link';

// A month-level issue (session_id 0) or one with no session to open reads as plain text, no link.
const SessionCell = ({ row }) =>
  row.session_id === 0 ||
  !row.session_uuid ||
  !row.session_start_text ||
  row.session_start_text === '—' ? (
    <span>{row.session_start_text || '—'}</span>
  ) : (
    <div>
      <SessionDateLink uuid={row.session_uuid} kind={row.session_kind} className="tp-rt-nowrap">
        {row.session_start_text}
      </SessionDateLink>
      {/* A name keeps its own case: secondary text, not an upper-case label (CD-42). */}
      {row.session_label || row.student_name ? (
        <div className="tp-sub">{row.session_label || row.student_name}</div>
      ) : null}
    </div>
  );

export default SessionCell;
